import 'mmenu-js/dist/mmenu.css';
import Mmenu from 'mmenu-js';

const init = async (block) => {
    return new Promise((resolve) => {
        const menu = new Mmenu(block,{
            "slidingSubmenus": false,
            "offCanvas": {
                "position": "left-front"
            },
            "theme": "dark",
            "hooks":{
                "open:before": () => {
                    // quickfix for gsap animation whitespace -> removes transform on open
                    document.querySelector('.mm-slideout').style.transform = null;
                },
                "open:finish": () => {
                    $('#search').focus();
                }
            }
        });

        const api = menu.API;

        document.querySelector( "#open-menu" )
            .addEventListener(
                "click", () => {
                    api.open();
                }
            );

        document.querySelector( "#open-search" )
            .addEventListener(
                "click", () => {
                    api.open();
                    setTimeout(() => document.querySelector(block + ' input[type=search]').focus(), 200)
                }
            );

        setTimeout(() => document.querySelector(block).style.display = 'block', 500);

        return resolve('Mmenu loaded')
    })
}

export { init }
